import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { Router } from '@angular/router'
import { VenueDetail } from '@monorepo-channels/channels/domain'

@Component({
	standalone: true,
	imports: [CommonModule, MatIconModule, MatButtonModule],
	selector: 'feature-porto-bank-checkin-unavailable',
	template: `
		<section style="display: flex; flex-direction: column; align-items: flex-start; gap: 16px;">
			<div
				style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding: 16px; "
			>
				<mat-icon svgIcon="porto-bank-icons:alert"></mat-icon>

				<mat-icon
					svgIcon="porto-bank-icons:close-circle"
					(click)="dialogRef.close()"
					style="cursor: pointer;"
				></mat-icon>
			</div>

			<h1 style="padding: 0 16px ; font-size: 22px; font-weight: 600; color: #000;">
				Check-in indisponível.
			</h1>
			<p style=" padding: 0 16px;  color: #000;">O check-in não está habilitado no momento.</p>

			<div style="padding: 16px; color: #000; background-color: #EAECF6; width: 100%">
				<p style="font-weight: 480; margin-bottom:10px; color: #000">Horário de check-in:</p>
				<p>De {{ checkin.time?.startTime }} às {{ checkin.time?.endTime }}</p>
			</div>

			<div style="display: flex; gap: 8px; align-self: flex-end; padding: 16px; ">
				<button
					mat-button
					(click)="dialogRef.close()"
					style="background-color: var(--content-primary); color: white; font-weight: 600; font-size: 15px; max-width: 55px; height: 30px"
				>
					Fechar
				</button>
			</div>
		</section>
	`,
})
export class CheckinUnavailableComponent {
	private router = inject(Router)
	public dialogRef = inject(MatDialogRef<CheckinUnavailableComponent>)
	private data: { checkin: VenueDetail['checkin']; venueId: string } = inject(MAT_DIALOG_DATA, {
		optional: true,
	})
	public checkin = this.data.checkin
	public venueId = this.data.venueId

	reserve() {
		this.dialogRef.close()
		this.router.navigate(['restaurante', this.venueId, 'reserva'])
	}
}
